/** The account (blocks 33, 34). Identity and plan are `/v1/me`; this is what acts on the account. */
import { accountDeletedSchema, exportJobSchema, } from "@nook/schema";
/** `202`; `nooks.json` arrives by email. `429` past 3 a day. */
export function requestExport(http) {
    return http.request({ path: "/v1/account/export", method: "POST", schema: exportJobSchema });
}
/** Deletes now: cancels billing and soft-deletes. The caller signs out after. */
export function deleteAccount(http, body) {
    return http.request({ path: "/v1/account", method: "DELETE", body, schema: accountDeletedSchema });
}
//# sourceMappingURL=account.js.map